export default {
  box: 'Box',
  prio: 'Prio',
  comment: 'Comment',
};
